module.exports = __webpack_public_path__ + "img/logo.a318fb2a.svg";